module.exports = "../images/economy-package.jpg?v=d392d27";